import { Tabs, TabPane } from '@app/components/common/Tabs/Tabs';
import * as S from './ResultDetailPage.styles';
import { useEffect, useState } from 'react';
import { Tag, TableProps } from 'antd';
import { useParams } from 'react-router-dom';
import { statusType } from '@app/utils/utils';
import { getResultDetail, IResultDetail } from '@app/api/result.api';
import { notificationController } from '@app/controllers/notificationController';
import { convertTypeParctice } from '@app/utils/utils';
import { TableResultCollapse } from '@app/components/exam/components/TableResultCollapse';
import { useTranslation } from 'react-i18next';

export const ResultDetailPage: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const [columns, setColumns] = useState<TableProps<IResultDetail>['columns']>([
    { title: '#', dataIndex: 'index', key: 'index', render: (_: any, __: any, index: number) => index + 1 },
    {
      title: t('page.results.type'),
      dataIndex: 'questionType',
      key: 'questionType',
      render: (questionType: string) => convertTypeParctice(questionType),
    },
    {
      title: t('page.results.status'),
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => (
        <Tag color={statusType[status]} key={status}>
          {t(`page.results.statusType.${status}`)}
        </Tag>
      ),
    },
    {
      title: t('page.results.totalScore'),
      dataIndex: 'score',
      key: 'score',
    },
  ]);

  const [resultLists, setResultLists] = useState<{
    speakingList: IResultDetail[];
    writingList: IResultDetail[];
    readingList: IResultDetail[];
    listeningList: IResultDetail[];
  }>({
    speakingList: [],
    writingList: [],
    readingList: [],
    listeningList: [],
  });

  useEffect(() => {
    fetchMockTestResult();
  }, [id]);

  const fetchMockTestResult = async () => {
    if (!id) return;
    try {
      const res = await getResultDetail(id);

      const groupedResults = res.reduce(
        (acc, item) => {
          if (item.questionType.startsWith('SPEAKING')) {
            acc.speakingList.push(item);
          } else if (item.questionType.startsWith('WRITING')) {
            acc.writingList.push(item);
          } else if (item.questionType.startsWith('READING')) {
            acc.readingList.push(item);
          } else if (item.questionType.startsWith('LISTENING')) {
            acc.listeningList.push(item);
          }
          return acc;
        },
        { speakingList: [], writingList: [], readingList: [], listeningList: [] } as {
          speakingList: IResultDetail[];
          writingList: IResultDetail[];
          readingList: IResultDetail[];
          listeningList: IResultDetail[];
        },
      );

      setResultLists(groupedResults);
    } catch (error) {
      notificationController.error({
        message: error,
      });
    }
  };

  return (
    <div className="flex flex-col rounded-lg bg-white p-8">
      <S.Title level={3}>{t('page.results.resultDetail')}</S.Title>

      <Tabs defaultActiveKey="1">
        <TabPane tab={t('common.speaking')} key="1">
          <TableResultCollapse columns={columns} dataSource={resultLists.speakingList} />
        </TabPane>
        <TabPane tab={t('common.writing')} key="2">
          <TableResultCollapse columns={columns} dataSource={resultLists.writingList} />
        </TabPane>
        <TabPane tab={t('common.reading')} key="3">
          <TableResultCollapse columns={columns} dataSource={resultLists.readingList} />
        </TabPane>
        <TabPane tab={t('common.listening')} key="4">
          <TableResultCollapse columns={columns} dataSource={resultLists.listeningList} />
        </TabPane>
      </Tabs>
    </div>
  );
};
